// extracted by mini-css-extract-plugin
module.exports = {"menu-icon":"MenuIcon_menu-icon__emJr7","active":"MenuIcon_active__i_kC_","menu-icon-inner":"MenuIcon_menu-icon-inner__Ue7NG","menu-icon-box":"MenuIcon_menu-icon-box__vYbdl"};